import { useSelector } from 'react-redux'
import { useFirebaseConnect, useFirestoreConnect } from 'react-redux-firebase'

import {
    ListItem,
    ListItemText,
    ListItemIcon,
    CircularProgress,
    ListItemSecondaryAction,
    IconButton
} from '@material-ui/core'
import DoneIcon from '@material-ui/icons/Done'
import Tooltip from '@material-ui/core/Tooltip'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward'

import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'

import { uploadFromDrive, uuid, humanFileSize, getCurrentAuth } from 'modules'

function CircularProgressWithLabel(props) {
    return (
        <Box position="relative" display="inline-flex">
            <CircularProgress variant={props.value ? 'determinate' : 'indeterminate'} {...props} />
            <Box
                top={0}
                left={0}
                bottom={0}
                right={0}
                position="absolute"
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                <Typography variant="caption" component="div" color="textSecondary">{`${Math.round(
                    props.value
                )}%`}</Typography>
            </Box>
        </Box>
    )
}

const GDriveFile = ({ file, uid, uploadedBy }) => {
    const baseRef = `gdrive/${uid}/${file.id}`

    useFirestoreConnect({
        collection: 'gdriveFiles',
        doc: file.id
    })
    useFirebaseConnect({
        path: `${baseRef}/progress`
    })
    const progress =
        useSelector(state => state.firebase.data.gdrive?.[uid]?.[file.id]?.progress) ?? -2
    const uploaded = !!useSelector(state => state.firestore.data?.gdriveFiles?.[file.id])

    const handleFileUpload = () => {
        const uploadId = uuid()
        uploadFromDrive({
            file,
            uid,
            uploadId,
            auth: { access_token: getCurrentAuth()?.access_token || '' },
            uploadedBy
        })
    }

    const showIcon = () => {
        if (progress >= -1 && progress < 100) {
            return <CircularProgressWithLabel value={progress < 0 ? 0 : progress} />
        }
        if (uploaded || progress === 100) {
            return (
                <Tooltip title="File has been uploaded">
                    <ListItemIcon>
                        <DoneIcon color="primary" />
                    </ListItemIcon>
                </Tooltip>
            )
        }
        return (
            <ListItemIcon>
                <ArrowUpwardIcon />
            </ListItemIcon>
        )
    }

    return (
        <ListItem role={undefined} dense>
            {showIcon()}
            <ListItemText primary={`${file.name} (${humanFileSize(file.size)})`} />

            <ListItemSecondaryAction onClick={handleFileUpload}>
                <Tooltip title="Upload this file to Guidde">
                    <IconButton
                        disabled={progress > -2 && progress < 100}
                        edge="end"
                        aria-label="comments"
                    >
                        <CloudUploadIcon />
                        <span style={{ paddingLeft: '10px', fontSize: '16px' }}> upload </span>
                    </IconButton>
                </Tooltip>
            </ListItemSecondaryAction>
        </ListItem>
    )
}

export default GDriveFile
